import { InjectionToken, Provider } from '@angular/core';

import { IonicPermanentStorageService, PermanentStorageService } from '@guardfinder/permanent-storage';

import { CreateJobFlowStateModel } from '../Domain/Model/CreateJobFlow/create-job-flow-state.model';
import { WebformCreateJobFlowState } from '../Domain/Port/CreateJob/webform-create-job-flow.state';
import { CreateJobModelFactory } from '../Infrastructure/Factory/create-job-model-factory.service';
import { CreateJobFlowNavigatorService } from '../Infrastructure/Service/create-job-flow/create-job-flow-navigator.service';
import { RestorableWebformCreateJobFlowStateService } from '../Infrastructure/Service/create-job-flow/restorable-webform-create-job-flow-state.service';

const storageKey = 'create_job_flow_state';
export const jobCreationFlowToken = new InjectionToken<PermanentStorageService<CreateJobFlowStateModel>>(storageKey);

/**
 * Provider for the Create Job Flow persistent storage service.
 *
 * This provider sets up a strongly-typed, feature-specific storage instance for job creation flow state,
 * using the generic storage abstraction and Ionic Storage as the backend.
 *
 * Usage:
 * - Add `provideJobCreationFlow()` to your component or module providers.
 * - Inject `jobCreationFlowToken` where you need to access or modify job creation flow state.
 */
export const provideJobCreationFlow = (): Provider[] => {
    return [
        {
            provide: jobCreationFlowToken,
            useFactory: () => new IonicPermanentStorageService<CreateJobFlowStateModel>(storageKey)
        },
        {
            provide: WebformCreateJobFlowState,
            useExisting: RestorableWebformCreateJobFlowStateService
        },
        CreateJobModelFactory,
        RestorableWebformCreateJobFlowStateService,
        CreateJobFlowNavigatorService
    ];
};
